import { Route, Routes, UrlMatcher, UrlSegment } from '@angular/router';

export function createCaseInsensitivePathMatcher(
  expectedPath: string,
  hasChildren = false
): UrlMatcher {
  const expectedParts = expectedPath.split('/').filter(Boolean);

  return (segments: UrlSegment[]) => {
    if (segments.length < expectedParts.length) {
      return null;
    }

    // Leaf routes must match the full remaining path; parent routes only
    // consume their own segment(s) and delegate the rest to children.
    if (!hasChildren && segments.length !== expectedParts.length) {
      return null;
    }

    const matches = expectedParts.every(
      (part, index) => segments[index].path.toLowerCase() === part.toLowerCase()
    );

    if (!matches) {
      return null;
    }

    return { consumed: segments.slice(0, expectedParts.length) };
  };
}

export function withCaseInsensitivePaths(routes: Routes): Routes {
  return routes.map((route) => applyCaseInsensitivePath(route));
}

function applyCaseInsensitivePath(route: Route): Route {
  const nextRoute: Route = { ...route };
  const hasChildren = !!route.children?.length;

  if (hasChildren) {
    nextRoute.children = withCaseInsensitivePaths(route.children!);
  }

  if (typeof route.path !== 'string' || route.path.length === 0) {
    return nextRoute;
  }

  const { path: _path, ...routeWithoutPath } = nextRoute;

  return {
    ...routeWithoutPath,
    matcher: createCaseInsensitivePathMatcher(route.path, hasChildren)
  };
}
